$(() => {
  const now = window.dayjs();

  const hidePastEvents = function () {
    const $this = $(this);
    const end = window.dayjs($this.data('end-date'));

    if (end.isBefore(now)) {
      $this.hide();
    }
  };

  // Main events page, upcoming. show up to 3 items, hide anything occuring in the past
  $('div.main-event-card').each(hidePastEvents);

  // Builiding ongoing events, hide things in the past.
  $('div.building-event-row').each(hidePastEvents);

  // media homepage events. show up to 3 items, hide anything occuring in the past
  $('div.event-card').each(hidePastEvents).filter(':visible:gt(2)').hide();

  // special collections homepage events. show up to 3 items, hide anything occuring in the past
  $('li.event-list-item').each(hidePastEvents).filter(':visible:gt(4)').hide();

  // Main events page, create filter selects using list.js
  if ($('#events-listing').length) {
    const options = {
      valueNames: [
        { name: 'department', attr: 'data-info' },
        { name: 'category', attr: 'data-info' },
        { name: 'date', attr: 'data-info' },
        'title',
      ],
    };

    const noItems = $('<div class="alert alert-warning">No Results. Try a different search string or filter options.</div>');
    const noOngoing = $('<div class="alert alert-warning">No Ongoing Events.</div>');
    const noFuture = $('<div class="alert alert-warning">No Upcoming Events.</div>');
    const eventsList = new window.List('events-listing', options);
    const futureList = new window.List('future-listing', options);
    const ongoingList = new window.List('ongoing-listing', options);
    const $filterControls = $('#filters').find('select.filter-controls');
    const $searchInput = $('#events-list-search');

    const scrollToTop = function () {
      $('body,html').scrollTop(0);
    };

    $searchInput.on('focus', () => {
        $filterControls.val('');
      })
      .on('keyup', function () {
        const val = $(this).val();
        eventsList.search(val, ['title']);
        futureList.search(val, ['title']);
        ongoingList.search(val, ['title']);
        scrollToTop();
      });

    $filterControls.on('change', function () {
      const $this = $(this);
      const which = $(this).data('controls');
      const searchString = $this.find(':selected').val();
      const $siblings = $this.siblings('select');

      $filterControls.removeClass('active');
      $this.addClass('active');
      $siblings.val('');
      $searchInput.val('');
      eventsList.search(searchString, [which]);
      futureList.search(searchString, [which]);
      ongoingList.search(searchString, [which]);
      scrollToTop();
      window.history.replaceState(null, null, `#${searchString}`);
    });

    $('.badge').on('click', function () {
      const which = $(this).data('list');
      const searchString = $(this).data('info');
      eventsList.search(searchString, [which]);
      futureList.search(searchString, [which]);
      ongoingList.search(searchString, [which]);
      scrollToTop();
      window.history.replaceState(null, null, `#${searchString}`);
    });

    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      eventsList.search(hash);
      eventsList.update();
      futureList.search(hash);
      futureList.update();
      ongoingList.search(hash);
      ongoingList.update();
    }

    eventsList.on('updated', (list) => {
      if (list.matchingItems.length === 0) {
        $(list.list).append(noItems);
      } else {
        noItems.detach();
      }
    });

    futureList.on('updated', (list) => {
      if (list.matchingItems.length === 0) {
        $(list.list).append(noFuture);
      } else {
        noFuture.detach();
      }
    });
    ongoingList.on('updated', (list) => {
      if (list.matchingItems.length === 0) {
        $(list.list).append(noOngoing);
      } else {
        noOngoing.detach();
      }
    });
  }
});
